import { Component, computed, input, signal, WritableSignal } from '@angular/core';
import { AuthManageSessionsGetParameters } from '@api/model/authManageSessionsGetParameters';
import { IDAuthSession } from '@api/model/iDAuthSession';
import { FilterConfig } from '@shared/components/filter/filter.model';
import { ACTION_DEFAULT_CONFIGS, actionConfig } from '@shared/components/list/ag-grid/cell-renderers/actions-cell-renderer.component';
import { IconCellRendererComponent, IIconCellRendererParams } from '@shared/components/list/ag-grid/cell-renderers/icon-cell-renderer.component';
import { INameCellRendererParams, NameCellRendererComponent } from '@shared/components/list/ag-grid/cell-renderers/name-cell-renderer.component';
import { ITextCellRendererParams, TextCellRendererComponent } from '@shared/components/list/ag-grid/cell-renderers/text-cell-renderer.component';
import { EntityListComponent } from "@shared/components/list/ag-grid/entity-list.component";
import { EntityListDirective } from '@shared/components/list/entity-list.directive';
import { CommonFunctions } from '@shared/services/common-functions.service';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { SessionListFeatureFlags } from './session-list.features';

@Component({
  selector: 'app-session-list',
  imports: [EntityListComponent],
  templateUrl: './session-list.component.html',
  styleUrl: './session-list.component.scss',
})
export class SessionListComponent extends EntityListDirective<SessionListFeatureFlags, IDAuthSession, AuthManageSessionsGetParameters, IDAuthSession[]>{
                        
    override getData = input<
        ((params: Partial<AuthManageSessionsGetParameters>) => Observable<IDAuthSession[] | undefined>)| undefined,
        ((params: Partial<AuthManageSessionsGetParameters>) => Observable<IDAuthSession[] | undefined>)| undefined
    >(undefined, {
        alias: 'get-data',
        transform: (call) => call ? (params: Partial<AuthManageSessionsGetParameters>) => call({
            ...params
        })
        : undefined
    });

    override ACTIONS_DEFINITIONS = computed<(params: ICellRendererParams<IDAuthSession, any, any>) => actionConfig[]>(() => {
        return (params: ICellRendererParams<IDAuthSession>) => {
            const actions = [];

            if(this.features().deleteSession.enabled){
                actions.push(ACTION_DEFAULT_CONFIGS.Delete);
            }

            return actions;
        }
    })

    override COLUMN_DEFINITIONS: WritableSignal<ColDef<any, any>[]> = signal<ColDef[]>([
        {
            cellRenderer: IconCellRendererComponent,
            cellRendererParams: (params: ICellRendererParams<IDAuthSession>) => {

                let icon = '';

                if(params.data?.detail.userAgent?.device?.isDesktop){
                    icon = 'desktop'
                }
                else if (params.data?.detail.userAgent?.device?.isTablet){
                    icon = 'tablet'
                }
                else if (params.data?.detail.userAgent?.device?.isMobile) {
                    icon = 'mobile'
                }

                return <IIconCellRendererParams>{
                    style: 'fas',
                    icon: icon
                }
            },
            sortable: false,
            initialWidth: 45,
            lockVisible: true,
            lockPinned: true,
            lockPosition: 'left',
            resizable: false,
        },
        {
            headerName: 'Name',
            field: CommonFunctions.getPropertyPathJoined<IDAuthSession>(session => session.detail.userAgent?.os?.name),
            cellRenderer: NameCellRendererComponent,
            cellRendererParams: <INameCellRendererParams>{
                additionalPaths: [
                    CommonFunctions.getPropertyPathJoined<IDAuthSession>(session => session.detail.userAgent?.browser?.name),
                ]
            }
        },
        {
            headerName: 'Session Created',
            field: CommonFunctions.getPropertyPathJoined<IDAuthSession>(session => session.detail.creationTimestamp),
            cellRenderer: TextCellRendererComponent,
            cellRendererParams: <ITextCellRendererParams>{
                format: 'date-time'
            }
        }
    ])

    filterOptions = computed<FilterConfig<AuthManageSessionsGetParameters>>(() => {
        return {
            groups: [
                {
                    name: 'Session',
                    filters: [
                    ]
                }
            ]
        }
    });

}
